import Content from '../../content.js';
import DataTables from '../../components/dataTables';

namespace('IO.Views.Servers', function (exports) {
  'use strict';

  var Index = Content.extend({
    dom: {
      CURRENT_TABLE: '.tabs-content .active table',
      FIRST_TAB: '#tab0Tab',
      TAB: '.tabs dd',
      FILTER_TRIGGER: '#servers-filter-trigger',
      SEARCH_FILTERS: '#servers-search-filters',
      SERVER_GROUP_FILTER: '#server-filter',
      SERVER_GROUP_FILTER_CONTAINER: '#server-group-filter',
      SERVER_GROUP: '.server-group',
      SERVER_GROUP_ANCHOR: '.server-group div',
      SERVER_GROUP_ACTIVE: '.server-group.active',
      SERVER_GROUP_BUTTON_BACK: '#server-group-back',
      SERVER_GROUP_BUTTON_EDIT: '.server-group-edit',
      NEW_SERVER_BUTTON:
        '.clearfix.server-actions .small.secondary.button.dropdown ul',
      DATATABLES_CONTAINER: '.datatables-container',
      SERVER_LISTING: '#server-groups-listing',
      SELECT2_FIELD: '.select2select',
    },

    /*
      PUBLIC FUNCTIONS
    */
    beforeRender: function () {
      this.groups = [];
      this.dataTables = [];
    },

    events: function () {
      var events = {};

      events['keyup ' + this.dom.SERVER_GROUP_FILTER] = '_filterNodeGroups';
      events['click ' + this.dom.SERVER_GROUP] = '_toggleNodeGroup';
      events['click ' + this.dom.SERVER_GROUP_BUTTON_EDIT] = '_viewNodeGroup';
      events['click ' + this.dom.FILTER_TRIGGER] = '_toggleFilters';
      events['click ' + this.dom.SERVER_GROUP_BUTTON_BACK] = '_reset';
      return events;
    },

    onDestroy: function () {
      _.each(this.dataTables, function (dataTable) {
        dataTable.remove();
      });

      this._offCheckablePropertiesUpdates();
    },

    render: function () {
      var $select;

      $select = this.$(this.dom.SELECT2_FIELD);

      $select.select2(
        window.select2Defaults({
          acceptNotFound: false,
          allowClear: false,
          placeholder: 'Any',
        }),
      );
    },

    afterRender: function () {
      var tab;

      if (window.location.hash === '') {
        return;
      }

      tab = window.location.hash.substr(1);

      if ($('.server-group[data-target=' + tab + ']').length > 0) {
        this._toggleNodeGroup(
          jQuery.Event('click', {
            currentTarget: $('.server-group[data-target=' + tab + ']:first')[0],
          }),
        );
      }
    },

    /*
      PRIVATE FUNCTIONS
    */
    _reset: function () {
      $(this.dom.DATATABLES_CONTAINER).removeClass('active');
      $(this.dom.SERVER_GROUP).removeClass('hidden-server-group active');
      $(this.dom.SERVER_GROUP_BUTTON_BACK).addClass('hidden');
      $(this.dom.SERVER_GROUP_FILTER_CONTAINER).removeClass('hidden');
      $(this.dom.NEW_SERVER_BUTTON).removeClass('hidden');
    },

    _viewNodeGroup: function (e) {
      e.stopPropagation();
    },

    _handleCheckablePropertyListeners: function () {
      // on nodes index, every time a group is changed on the groups dropdown the listener has to change
      // and listen to different update events
      this._offCheckablePropertiesUpdates();
      this._listenCheckablePropertyUpdates();
    },

    _listenCheckablePropertyUpdates: function () {
      var owner, accessor;

      if (window.location.hash === '') {
        return;
      }

      this.checkablePropertiesChannel = `/service_check_value_${$('.active').find('.group-id').val()}`;
      this.subscriptionId = Messenger.on(
        this.checkablePropertiesChannel,
        (data) => {
          owner = data.hostname;

          data.changes.forEach((propData) => {
            accessor = `.${owner}.${propData.property_id}`;
            this._handleCheckablePropertyUpdate(propData, accessor);
          });
        },
      );
    },

    _offCheckablePropertiesUpdates: function () {
      if (typeof this.subscriptionId === 'undefined') {
        return;
      }

      Messenger.off(this.checkablePropertiesChannel, this.subscriptionId);
      this.subscriptionId = undefined;
    },

    _handleCheckablePropertyUpdate: function (data, _target) {
      var target = $(_target);

      if (
        !data.metadata.remote_error_at ||
        moment(data.metadata.remote_updated_at).valueOf() >
          moment(data.metadata.remote_error_at).valueOf()
      ) {
        target.removeClass('has-error');
        target.html(data.metadata.remote_value);
      } else {
        target.addClass('has-error');
        target.html('Error');
      }
    },

    _filterNodeGroups: function (e) {
      var filterText = $(e.currentTarget).val();

      if (filterText !== '') {
        $(
          this.dom.SERVER_GROUP + ':not(:contains(' + filterText + '))',
        ).addClass('hidden-server-group');

        $(this.dom.SERVER_GROUP + ':contains(' + filterText + ')').removeClass(
          'hidden-server-group',
        );
      } else {
        $(this.dom.SERVER_GROUP).removeClass('hidden-server-group');
      }
    },

    _isDataTableInstantiated: function (table, group) {
      return table.length > 1 && this.groups.indexOf(group) !== -1;
    },

    _toggleNodeGroup: function (e) {
      var nodeGroup;

      e.preventDefault();

      if (e.currentTarget.className.indexOf('active') !== -1) {
        return false;
      }

      nodeGroup = $(e.currentTarget);
      window.location.hash = '#' + nodeGroup.data('target');

      $(this.dom.SERVER_GROUP).removeClass('active');
      $(this.dom.SERVER_GROUP_FILTER_CONTAINER).addClass('hidden');
      $(this.dom.NEW_SERVER_BUTTON).addClass('hidden');
      $(this.dom.SERVER_GROUP_FILTER).val('');
      nodeGroup.addClass('active');
      $(this.dom.SERVER_GROUP + ':not(.active)').addClass(
        'hidden-server-group',
      );
      $(this.dom.SERVER_GROUP_BUTTON_BACK).removeClass('hidden');

      this._lazyDrawDatatable(nodeGroup);

      $('html, body').animate(
        {
          scrollTop: 0,
        },
        0,
      );

      this._handleCheckablePropertyListeners();
    },

    _lazyDrawDatatable: function (groupElement) {
      var group = groupElement.data('target'),
        targetDatatable = $('#' + group),
        table = targetDatatable.find('table'),
        dataTable,
        columns,
        initializedTable;

      $(this.dom.DATATABLES_CONTAINER).removeClass('active');
      targetDatatable.addClass('active');

      if (this._isDataTableInstantiated(table, group) === true) {
        initializedTable = this.dataTables[this.groups.indexOf(group)];

        if (initializedTable !== undefined) {
          initializedTable.table.fnPageChange(0);
          initializedTable._adjustColumnSizing();
        }
      } else {
        columns = window.column_data[table.data('group-key')];

        dataTable = new DataTables({
          el: table,
          controller: 'servers',
          columns: columns,
          fixed: false,
          filter: true,
          serverSide: true,
          ajaxSource: 'servers.json?group=' + table.data('group-id'),
          title: 'Click to edit',
          sorting: [[0, 'desc']],
          aoColumnDefs: [
            {
              targets: 0,
              className: 'one column wide',
              // Attaches sensu status span element to all status data.
              render: (data) =>
                '<span class="ir sensu-status sensu-status-12px sensu-status-datatables sensu-status-' +
                data +
                ' title="' +
                data +
                '">' +
                (data === 'online' ? 1 : 0) +
                '</span>',
            },
          ],
        });

        dataTable.start();

        this.groups.push(group);
        this.dataTables.push(dataTable);
      }
    },

    _toggleFilters: function (e) {
      e.preventDefault();
      this.$(this.dom.FILTER_TRIGGER).toggleClass('-active');
      this.$(this.dom.SEARCH_FILTERS).toggle();
    },
  });

  exports.Index = Index;
});
